import Inputmask from 'inputmask/dist/inputmask.es6'
import 'clockpicker/dist/bootstrap-clockpicker'

let els = $('.clockpicker')

els.clockpicker({
    autoclose: true
});

els.each(function() {
    Inputmask({
        alias: 'datetime',
        inputFormat: 'H2:MM',
        max: '23:59',
        placeholder: '__:__',
        clearMaskOnLostFocus: false,
        autoUnmask: true,
        removeMaskOnSubmit: true,
    }).mask(this)
})
